export default __webpack_public_path__ + "static/media/hero-bcg.aec7c62b.jpg";